import { Items } from 'src/app/core/models/common/items.model';

export enum ColumnIds {
  TRACKING_NUMBER = 'trackingNumber',
  SORT_DATE = 'sortDate',
  SORT_CODE = 'sortCode',
  LENGTH = 'length',
  WIDTH = 'width',
  HEIGHT = 'height',
  UDW_TYPE = 'udwType',
}

export const CONST = {
  SELECT_DATE: $localize`Select Date`,
  SIZE_AUDIT: $localize`Size Audit`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  ENTER_TRACKING_NUMBER: $localize`Enter or upload Tracking Numbers`,
  FILE_UPLOAD: $localize`File Upload`,
  SUBMIT: $localize`Submit`,
  SELECT: $localize`Select`,
  SORT_CODE: $localize`Sort Code`,
  TRACKING_NUMBER_INVALID_ERROR: $localize`Please enter a valid Tracking Number`,
  PALLET: $localize`Pallet`,
  LENGTH: $localize`Length`,
  WIDTH: $localize`Width`,
  HEIGHT: $localize`Height`,
  INVALID_DIMENSION: $localize`Invalid Dimension`,
  WARNING_MODAL: {
    HEADER: $localize`Warning `,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
};

export enum UowType {
  PALLET = 'Pallet',
  PACKAGE = 'Package',
}
export const ColumnText = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  SORT_DATE: $localize`Sort Date`,
  SORT_CODE: $localize`Sort Code`,
  LENGTH: $localize`Length (%unit)`,
  WIDTH: $localize`Width (%unit)`,
  HEIGHT: $localize`Height (%unit)`,
  UOW_TYPE: $localize`UOW Type`,
};

export const EXCEL_FILE_NAME = $localize`inbound-scan`;

export type SizeAudit = {
  trackingNumber: string;
  sortDate: string;
  sortCode: string;
  length: string;
  width: string;
  height: string;
  udwType: string;
};

export const SORT_OPTIONS: Items[] = [
  { id: 'D1', selected: true },
  { id: 'D3', selected: true },
  { id: 'D9', selected: true },
  { id: 'L1', selected: true },
  { id: 'P1', selected: true },
  { id: 'P4', selected: true },
  { id: 'P7', selected: true },
  { id: 'S1', selected: true },
  { id: 'S7', selected: true },
];

export const SORT_OPTION_LIST = [...SORT_OPTIONS].map((item) => {
  return {
    label: item.id,
    value: item.id,
  };
});

export const MOCK_TABLE_CONSTS: SizeAudit[] = [
  {
    trackingNumber: '1Z937254729',
    sortDate: 'May 2, 2023',
    sortCode: 'L1',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z1212121212',
    sortDate: 'May 8, 2023',
    sortCode: 'L1',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 3, 2023',
    sortCode: 'D1',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z1212121212',
    sortDate: 'May 6, 2023',
    sortCode: 'D3',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z987654321',
    sortDate: 'May 6, 2023',
    sortCode: 'D9',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z123456789',
    sortDate: 'May 8, 2023',
    sortCode: 'D9',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 6, 2023',
    sortCode: 'P1',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254729',
    sortDate: 'May 10, 2023',
    sortCode: 'P4',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 2, 2023',
    sortCode: 'P4',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 9, 2023',
    sortCode: 'P7',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 4, 2023',
    sortCode: 'S1',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
  {
    trackingNumber: '1Z123456789',
    sortDate: 'May 5, 2023',
    sortCode: 'S7',
    length: '10',
    width: '10',
    height: '10',
    udwType: 'Pallet',
  },
];
